var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCykelrute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Cirkel"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    ry: 7.795,
    fill: "#427c7f"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "ICONS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.213,10.615c.898,0,1.629-.731,1.629-1.629,0-.395-.147-.753-.382-1.035l.524-.525c.027-.027.038-.062.04-.097l.259.174-.11,1.349c-.017.207.138.387.344.404.011,0,.021.001.03.001.193,0,.357-.148.374-.345l.055-.68,1.37-1.169.107.401c-.621.23-1.066.823-1.066,1.522,0,.898.73,1.629,1.629,1.629s1.628-.731,1.628-1.629-.73-1.628-1.628-1.628c-.094,0-.184.012-.274.028l-.308-1.15c.087-.053.159-.128.181-.236.04-.204-.093-.4-.296-.441l-.933-.184-.593-.877c-.018-.027-.043-.045-.066-.065-.016-.017-.024-.039-.041-.054-.249-.218-.628-.195-.847.055l-1.081,1.229c-.181.205-.187.495-.047.714.019.036.044.066.073.096.011.011.016.026.028.036.006.005.014.007.02.012.008.006.012.015.02.02l.97.653c-.017.007-.037.007-.051.021l-.524.524c-.282-.234-.64-.381-1.035-.381-.898,0-1.629.73-1.629,1.628s.73,1.629,1.629,1.629Zm4.659-1.59c.018.067.078.111.145.111.013,0,.025-.001.039-.005.08-.021.127-.104.105-.184l-.31-1.156c.056-.008.107-.033.165-.033.677,0,1.228.551,1.228,1.228s-.551,1.229-1.228,1.229-1.229-.551-1.229-1.229c0-.515.32-.953.77-1.135l.314,1.174Zm-2.336-3.569l.315.467c.055.082.141.139.238.158l1.049.207.122.454-1.249,1.066.05-.615c.003-.032-.006-.061-.011-.091,0-.004,0-.008-.001-.012-.009-.046-.026-.088-.051-.126-.008-.014-.014-.028-.023-.042-.002-.003-.005-.004-.007-.007-.03-.041-.063-.079-.108-.109l-.95-.639.626-.712Zm-1.125,3.38h-.836l.591-.592c.132.169.216.369.244.592Zm-1.198-1.078c.284,0,.533.112.741.274l-.848.848c-.043.043-.056.107-.032.164.023.056.078.092.139.092h1.198c-.077.604-.574,1.079-1.198,1.079-.678,0-1.229-.551-1.229-1.229s.551-1.228,1.229-1.228Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.421,4.382c.394,0,.714-.32.714-.714s-.32-.714-.714-.714-.714.32-.714.714.32.714.714.714Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.557,11.651H3.033c-.083,0-.15.067-.15.15s.067.15.15.15h9.524c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.016,12.499H3.574c-.083,0-.15.067-.15.15s.067.15.15.15h8.442c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCykelrute);
export default __webpack_public_path__ + "static/media/CYKELRUTE.7bc0dc4e144d8218c0da1fffc74975c2.svg";
export { ForwardRef as ReactComponent };